/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";

/** @module core/modules/stringify-primitive */

/**
 * @description Receives any primitive as input and returns its string version.
 * @param {*} input - Input value.
 * @returns {string} String result.
 */
function stringifyPrimitive(input) {
  if (typeof input === 'undefined') {
    return 'undefined';
  } else {
    return _JSON$stringify(input);
  }
}

export { stringifyPrimitive };